import styled from 'styled-components';
import Button from 'syf-component-library/ui/atoms/Button';
import { fontSizes } from 'syf-component-library/defaultTheme';
const ManagePaymentSecurityLink = styled(Button) `
  display: inline-block;
  font-size: ${fontSizes.root}px;
  padding: 0;
  margin: 0;
`;
export default ManagePaymentSecurityLink;
